var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"v2-iframe",attrs:{"id":"iframe-partner","src":"/v2/contacto-prestador"}})
}
var staticRenderFns = []

export { render, staticRenderFns }